import { useMutation } from '@tanstack/react-query'
import { uploadVmsTimesheet } from 'api/admin/vms/uploadVmsTimesheet'

export const useUploadVmsTimesheetMutation = () =>
  useMutation({
    mutationFn: uploadVmsTimesheet,
  })
